import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { contractsApi, Contract } from '../../api/contractsApi';
import { incomeExpenseApi, ProjectBankAccount } from '../../api/incomeExpenseApi';

const CreateExpenditureVoucherPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [contract, setContract] = useState<Contract | null>(null);
  const [accounts, setAccounts] = useState<ProjectBankAccount[]>([]);
  const [amount, setAmount] = useState('');
  const [projectBankAccountId, setProjectBankAccountId] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('BANK_TRANSFER');
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id) load();
  }, [id]);

  const load = async () => {
    if (!id) return;
    const data = await contractsApi.getById(id);
    setContract(data);
    setAmount(String(data.valueWithVat || ''));
    const bankAccounts = await incomeExpenseApi.listProjectBankAccounts(data.buildingId);
    setAccounts(bankAccounts);
    const defaultAccount = bankAccounts.find((a) => a.isDefault) || bankAccounts[0];
    if (defaultAccount) setProjectBankAccountId(defaultAccount.id);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id || !projectBankAccountId || !amount) {
      toast.error('Vui lòng điền đầy đủ thông tin');
      return;
    }
    setSaving(true);
    try {
      await contractsApi.createExpenditureVoucher(id, {
        amount: Number(amount),
        projectBankAccountId,
        paymentMethod,
        notes: notes || undefined,
      });
      toast.success('Đã tạo phiếu chi');
      navigate('/contracts/expenditure');
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Không thể tạo phiếu chi');
    } finally {
      setSaving(false);
    }
  };

  if (!contract) return <div className="p-6">Đang tải...</div>;

  return (
    <div className="p-6 max-w-lg">
      <h1 className="text-xl font-bold mb-4">Tạo phiếu chi — {contract.code}</h1>
      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded border">
        <div>
          <label className="block text-sm font-medium mb-1">Số tiền</label>
          <input type="number" className="w-full border rounded px-3 py-2" value={amount} onChange={(e) => setAmount(e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Tài khoản dự án</label>
          <select className="w-full border rounded px-3 py-2" value={projectBankAccountId} onChange={(e) => setProjectBankAccountId(e.target.value)}>
            {accounts.map((a) => (
              <option key={a.id} value={a.id}>{a.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Hình thức thanh toán</label>
          <select className="w-full border rounded px-3 py-2" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
            <option value="BANK_TRANSFER">Chuyển khoản</option>
            <option value="CASH">Tiền mặt</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Ghi chú</label>
          <textarea className="w-full border rounded px-3 py-2" value={notes} onChange={(e) => setNotes(e.target.value)} />
        </div>
        <button type="submit" disabled={saving} className="px-4 py-2 bg-green-600 text-white rounded disabled:opacity-50">
          {saving ? 'Đang tạo...' : 'Tạo phiếu chi'}
        </button>
      </form>
    </div>
  );
};

export default CreateExpenditureVoucherPage;
